type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  loaded?: boolean;
  push?: (...args: unknown[]) => void;
  queue: unknown[][];
  version?: string;
};

declare global {
  interface Window {
    _fbq?: MetaPixelFunction;
    fbq?: MetaPixelFunction;
  }
}

const META_PIXEL_ID = '26499789893011873';
const META_PIXEL_SCRIPT_SOURCE =
  'https://connect.facebook.net/en_US/fbevents.js';

let isMetaPixelInitialized = false;
let isMetaPixelUnavailable = false;

const disableMetaPixel = () => {
  isMetaPixelUnavailable = true;

  if (window.fbq) {
    window.fbq.queue = [];
  }
};

const getMetaPixel = () => {
  if (window.fbq) {
    return window.fbq;
  }

  const fbq = ((...args: unknown[]) => {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
      return;
    }

    fbq.queue.push(args);
  }) as MetaPixelFunction;

  fbq.queue = [];
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';

  window.fbq = fbq;
  window._fbq = fbq;

  return fbq;
};

const injectMetaPixelScript = () => {
  if (document.querySelector(`script[src="${META_PIXEL_SCRIPT_SOURCE}"]`)) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = META_PIXEL_SCRIPT_SOURCE;
  script.addEventListener('error', disableMetaPixel);

  const firstScript = document.getElementsByTagName('script')[0];

  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
    return;
  }

  document.head.appendChild(script);
};

export const initializeMetaPixel = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  if (isMetaPixelInitialized || isMetaPixelUnavailable) {
    return;
  }

  const fbq = getMetaPixel();

  injectMetaPixelScript();
  fbq('init', META_PIXEL_ID);

  isMetaPixelInitialized = true;
};

export const trackMetaPageView = () => {
  if (typeof window === 'undefined' || !window.fbq || isMetaPixelUnavailable) {
    return;
  }

  window.fbq('track', 'PageView');
};
